webpackJsonp([82],{

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["content", "visible"]
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ServiceTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RideTypeTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TaggingTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ServiceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AmountTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DaysArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AncillaryCalculationTypeArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AncillaryCalculationType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GeneralSurchargeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DefaultTableObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UserPermissionGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return WaitingTimeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ConversionFormula; });
/* unused harmony export Currencies */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PreBookingItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PostBookingItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CurrencyFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UserType; });
var ServiceTypes = [{ value: 1, text: "Transfer" }, { value: 2, text: "Hourly" }];

var RideTypeTypes = [{ value: "B", text: "Business" }, { value: "P", text: "Personal" }, { value: "G", text: "Guest" }, { value: "O", text: "Other" }];

var TaggingTypes = [{ value: "Tariff", text: "Tariff" }, { value: "Vehicle", text: "Vehicle" }, { value: "Zone", text: "Zone" }];

var ServiceType = {
  AirportTransferText: "AirportTransfer",
  AirportTransferEnum: 1,
  RentalHourlyText: "Rental",
  RentalHourlyEnum: 2
};

var AmountTypes = [{ value: 1, text: "Flat" }, { value: 2, text: "Percentage" }];

var DaysArray = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

var AncillaryCalculationTypeArray = [{ value: 1, text: "One Time Calculate" }, { value: 2, text: "Per Day Calculate" }];

var AncillaryCalculationType = {
  OneTimeCalculate: 1,
  PerDayCalculate: 2
};

var GeneralSurchargeType = {
  NightTime: 1,
  Weekend: 2,
  GarageTime: 3,
  Others: 4
};

var DefaultTableObject = {
  keyword: "",
  totalPages: 1,
  totalRecords: 0,
  pageNumber: 1,
  pageSize: 25,
  pageSizes: [25, 50, 100],
  items: []
};

var UserPermissionGroup = {
  AirportTransferReservation: "InquiryReservation",
  HourlyReservation: "InstantReservation",
  InquiryAvailability: "InquiryAvailability",
  InstantAvailability: "InstantAvailability"
};

var WaitingTimeType = [{ value: 1, text: "Airport Arrival" }, { value: 2, text: "Non-Airport Arrival" }, { value: 3, text: "Extra Stop" }, { value: 4, text: "Extra Stop Waiting Time" }];

var ConversionFormula = {
  MultiplicationValue: "Multiplication",
  DivisionValue: "Multiplication"
};

var Currencies = [{ value: "AUD", text: "Australian Dollar" }, { value: "CAD", text: "Canadian Dollar" }, { value: "CHF", text: "Swiss Franc" }, { value: "CNY", text: "China Yuan" }, { value: "EUR", text: "Euro" }, { value: "GBP", text: "British Pound" }, { value: "HKD", text: "Hongkong Dollar" }, { value: "JPY", text: "Japanese Yen" }, { value: "NZD", text: "New Zealand Dollar" }, { value: "SGD", text: "Singapore Dollar" }, { value: "THB", text: "Thai Baht" }, { value: "USD", text: "US Dollar" }];

var PreBookingItem = {
  baseLabel: "Base",
  markupLabel: "Markup",
  nightHourSurchargeLabel: "Morning/Night/Peak-Hour",
  peakPeriodSurchargeLabel: "Peak-Period Surcharge",
  weekendSurchargeLabel: "Weekend Surcharge"
};

var PostBookingItem = {
  extraStopLabel: "Extra Stop",
  fareParkingLabel: "Parking Fare",
  fareTollLabel: "Toll Fare",
  noShowLabel: "No Show",
  waitingTimeLabel: "Waiting Time",
  overtimeLabel: "Overtime"
};

var CurrencyFormat = [{ Currency: "AED", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "ALL", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "AMD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "ANG", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "AOA", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "ARS", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "AUD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "AWG", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "AZN", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BAM", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BBD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BDT", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BGN", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BHD", DecimalPoint: 3, Format: "0,0.000" }, { Currency: "BMD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BND", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BOB", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BRL", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BSD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BWP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BYN", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "BZD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "CAD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "CHF", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "CLP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "CNY", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "COP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "CRC", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "CUP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "CVE", DecimalPoint: 0, Format: "0,0" }, { Currency: "CZK", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "DJF", DecimalPoint: 0, Format: "0,0" }, { Currency: "DKK", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "DOP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "DZD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "EGP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "ETB", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "EUR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "FJD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "FKP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "GBP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "GEL", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "GHS", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "GIP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "GMD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "GNF", DecimalPoint: 0, Format: "0,0" }, { Currency: "GTQ", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "GYD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "HKD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "HNL", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "HTG", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "HUF", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "IDR", DecimalPoint: 0, Format: "0,0" }, { Currency: "ILS", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "INR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "IQD", DecimalPoint: 3, Format: "0,0.000" }, { Currency: "ISK", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "JMD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "JOD", DecimalPoint: 3, Format: "0,0.000" }, { Currency: "JPY", DecimalPoint: 0, Format: "0,0" }, { Currency: "KES", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "KGS", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "KHR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "KMF", DecimalPoint: 0, Format: "0,0" }, { Currency: "KRW", DecimalPoint: 0, Format: "0,0" }, { Currency: "KWD", DecimalPoint: 3, Format: "0,0.000" }, { Currency: "KYD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "KZT", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "LAK", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "LBP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "LKR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "LYD", DecimalPoint: 3, Format: "0,0.000" }, { Currency: "MAD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MDL", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MKD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MMK", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MNT", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MOP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MRU", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MUR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MVR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MWK", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MXN", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MYR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "MZN", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "NAD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "NGN", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "NIO", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "NOK", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "NPR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "NZD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "OMR", DecimalPoint: 3, Format: "0,0.000" }, { Currency: "PAB", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "PEN", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "PGK", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "PHP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "PKR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "PLN", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "PYG", DecimalPoint: 0, Format: "0,0" }, { Currency: "QAR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "RON", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "RSD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "RUB", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "RWF", DecimalPoint: 0, Format: "0,0" }, { Currency: "SAR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "SBD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "SCR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "SEK", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "SGD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "SHP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "SLE", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "SOS", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "SRD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "STN", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "SVC", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "SZL", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "THB", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "TND", DecimalPoint: 3, Format: "0,0.000" }, { Currency: "TOP", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "TRY", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "TTD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "TWD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "TZS", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "UAH", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "UGX", DecimalPoint: 0, Format: "0,0" }, { Currency: "USD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "UYU", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "UZS", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "VEF", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "VND", DecimalPoint: 0, Format: "0,0" }, { Currency: "VUV", DecimalPoint: 0, Format: "0,0" }, { Currency: "WST", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "XAF", DecimalPoint: 0, Format: "0,0" }, { Currency: "XCD", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "XOF", DecimalPoint: 0, Format: "0,0" }, { Currency: "XPF", DecimalPoint: 0, Format: "0,0" }, { Currency: "YER", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "ZAR", DecimalPoint: 2, Format: "0,0.00" }, { Currency: "ZMW", DecimalPoint: 2, Format: "0,0.00" }];

var UserType = {
  UnspecifiedLabel: "Unspecified",
  TenantUserLabel: "TenantUser",
  ProviderUserLabel: "ProviderUser",
  CorporateUserLabel: "CorporateUser"
};

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_progressbar__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_blockui__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_ctk_date_time_picker__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_ctk_date_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_ctk_date_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuejs_paginate__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_authService_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_stars__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_stars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_stars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_eventBus_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_global_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_numberHelper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_shared_Loader__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_select_dist_vue_select_css__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_currency_input__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_advanced_cropper__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_advanced_cropper_dist_style_css__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_advanced_cropper_dist_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_advanced_cropper_dist_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__kugatsu_vuenotification__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__kugatsu_vuenotification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__kugatsu_vuenotification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_multiselect__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuelidate__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_quill_editor__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__plugins_firebase_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_quill_dist_quill_core_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_quill_dist_quill_snow_css__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_quill_dist_quill_bubble_css__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_quill_dist_quill_bubble_css__);




var _this = this;






























 // import styles
 // for snow theme
 // for bubble theme

var gmtNumber = Object(__WEBPACK_IMPORTED_MODULE_17__helpers_numberHelper__["e" /* extractTextAfterGMT */])(Intl.DateTimeFormat("en-US", {
  dateStyle: "full",
  timeStyle: "long"
}).format());

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_28_vue_quill_editor___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_progressbar___default.a, {
  color: "#4FB848",
  failedColor: "#874b4b",
  thickness: "3px",
  transition: {
    speed: "1s",
    opacity: "0.6s",
    termination: 300
  },
  autoRevert: true,
  location: "top",
  inverse: false
});
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_blockui__["default"]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_21_vue_currency_input__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_22_vue_advanced_cropper__["a" /* Cropper */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_24__kugatsu_vuenotification___default.a, {
  timer: 5,
  position: "topRight",
  showLeftIcn: true,
  showCloseIcn: true,
  buttonClicked: true
});
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_27_vuelidate___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component("VueCtkDateTimePicker", __WEBPACK_IMPORTED_MODULE_10_vue_ctk_date_time_picker___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component("paginate", __WEBPACK_IMPORTED_MODULE_12_vuejs_paginate___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component("vue-stars", __WEBPACK_IMPORTED_MODULE_14_vue_stars__["VueStars"]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component("loader", __WEBPACK_IMPORTED_MODULE_18__components_shared_Loader__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component("v-select", __WEBPACK_IMPORTED_MODULE_19_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component("Multiselect", __WEBPACK_IMPORTED_MODULE_25_vue_multiselect___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_7_axios___default.a.interceptors.request.use(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(config) {
    var publicRouteSetup;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app !== null) {
              __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app.$Progress.start();
            }

            config.headers.Timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            config.headers.TimezoneAbbr = gmtNumber;
            // config.headers.Authorization = `Bearer ${await auth.getAcessToken()}`
            config.headers.Currency = localStorage.getItem("selectedCurrency") || "SGD";

            publicRouteSetup = config.headers["_pub"];

            if (!(!publicRouteSetup || publicRouteSetup === "false")) {
              _context.next = 10;
              break;
            }

            _context.next = 8;
            return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch("user/getToken");

          case 8:
            _context.t0 = _context.sent;
            config.headers.Authorization = "Bearer " + _context.t0;

          case 10:
            return _context.abrupt("return", config);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  if (__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app !== null) {
    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app.$Progress.fail();
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_7_axios___default.a.interceptors.response.use(function (response) {
  // complete the progress bar
  if (__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app !== null) {
    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app.$Progress.finish();
  }
  return response;
}, function (error) {
  if (__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app !== null) {
    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app.$Progress.fail();
  }
  if (error.response && error.response.status === 401 && error.config) {
    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
      path: "/logout"
    });
  } else if (error.message === "Network Error") {
    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
      path: "/server-error"
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$authService = __WEBPACK_IMPORTED_MODULE_13__services_authService_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$eventBus = __WEBPACK_IMPORTED_MODULE_15__plugins_eventBus_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$helper = __WEBPACK_IMPORTED_MODULE_16__plugins_global_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$currencyFormat = __WEBPACK_IMPORTED_MODULE_17__helpers_numberHelper__["d" /* currencyFormat */];

if (!__WEBPACK_IMPORTED_MODULE_29__plugins_firebase_js__["a" /* firebaseAuth */].currentUser) {
  __WEBPACK_IMPORTED_MODULE_29__plugins_firebase_js__["a" /* firebaseAuth */].signInWithEmailAndPassword("app.core@trransfer.com", "trransfer123").then(function () {
    console.log("Firebase: Signed in automatically.");
  }).catch(function (err) {
    console.error("Auto sign-in failed:", err.message);
  });
}

var vm = new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]);
  }
}).$mount("#app");

/* harmony default export */ __webpack_exports__["default"] = (vm);

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebaseAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return firebaseDB; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(316);




// dev & stag
// const firebaseConfig = {
//   apiKey: "AIzaSyAc7RJh_7p8RNtJTwhNbpJt6xFpZ4LM6F4",
//   authDomain: "trransferdevstag.firebaseapp.com",
//   databaseURL:
//     "https://trransferdevstag-default-rtdb.asia-southeast1.firebasedatabase.app/",
//   // databaseURL: "https://trransferstag.asia-southeast1.firebasedatabase.app/",
//   projectId: "trransferdevstag",
//   storageBucket: "trransferdevstag.firebasestorage.app",
//   messagingSenderId: "659349317020",
//   appId: "1:659349317020:web:dc34cff169a276c0d81459",
//   measurementId: "G-1W47FKXBYS"
// };

// prod
var firebaseConfig = {
  apiKey: "AIzaSyDWI2z8815rnq-lF5UH4bzXbECcAsIfaUI",
  authDomain: "trransferprod.firebaseapp.com",
  databaseURL: "https://trransferprod-default-rtdb.asia-southeast1.firebasedatabase.app/",
  projectId: "trransferprod",
  storageBucket: "trransferprod.firebasestorage.app",
  messagingSenderId: "643426386128",
  appId: "1:643426386128:web:838abdb8b22c8ec8d99ed5",
  measurementId: "G-XQRNQBBS0D"
};

__WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].initializeApp(firebaseConfig);

var firebaseAuth = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth();

var firebaseDB = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].database();



/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/identityUsers';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getById: function getById(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/item/id/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getProfile: function getProfile() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/profile').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  reactivate: function reactivate(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/reactivate', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  deactivate: function deactivate(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/deactivate', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  delete: function _delete(id) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  forgotPassword: function forgotPassword(request) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/forgotpassword', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context9.abrupt('return', _context9.sent);

            case 3:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  changePassword: function changePassword(request) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/changepassword', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context10.abrupt('return', _context10.sent);

            case 3:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  syncAuth: function syncAuth(request) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/sync', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context11.abrupt('return', _context11.sent);

            case 3:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/settings';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getByKeys: function getByKeys(keys) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + keys)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllPublic: function getAllPublic() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/public').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1c199f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(276);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1c199f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"overlay"}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_index_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_shoppingModule__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_onBoardingModule__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_reportModule__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_jobBrowserModule__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_fleetMasterModule__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_geofenceModule__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_buyingTariffModule__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_sellingTariffModule__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_corporateModule__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_financeModule__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_administrationModule__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_securityModule__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_paymentModule__ = __webpack_require__(331);




var _this = this;



















__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: "history",
  base: "/",
  routes: [{
    path: "*",
    name: "404",
    component: function component() {
      return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 454));
    }
  }, {
    path: "",
    component: function component() {
      return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 455));
    },
    children: [{
      path: "/",
      name: "Home",
      component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 456));
      },
      meta: {
        title: "Home",
        requiresAuth: true
      }
    }, {
      path: "/guide",
      name: "Guide",
      component: function component() {
        return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 457));
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: "/profile",
      name: "Profile",
      component: function component() {
        return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 458));
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: "/logout",
      name: "Logout",
      component: function component() {
        return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 459));
      }
    }, {
      path: "/unauthorized",
      name: "401",
      component: function component() {
        return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 460));
      }
    }, {
      path: "/server-error",
      name: "500",
      component: function component() {
        return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 461));
      }
    }, {
      path: "/repricing/:id",
      name: "Repricing",
      component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 385));
      }
    }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__modules_shoppingModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__modules_onBoardingModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__modules_reportModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__modules_jobBrowserModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__modules_fleetMasterModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__modules_geofenceModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__modules_buyingTariffModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__modules_sellingTariffModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__modules_corporateModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__modules_financeModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__modules_administrationModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_17__modules_securityModule__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_18__modules_paymentModule__["a" /* default */]))
  }, {
    path: "",
    component: function component() {
      return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 462));
    },
    children: [{
      path: "/reservation/:reservation_id/amend/:amendment_id/respond",
      name: "AmendConfirmation",
      component: function component() {
        return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 463));
      },
      meta: {
        requiresAuth: false,
        services: []
      }
    }, {
      path: "/invoices/:invoice_id/pub",
      name: "InvoiceInformation",
      component: function component() {
        return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 464));
      },
      meta: {
        requiresAuth: false,
        services: []
      }
    }]
    //   {
    //     path: '/dashboard/tenant',
    //     name: 'TenantDashboard',
    //     component: () => import('@/components/dashboard/TenantDashboard'),
    //     meta: {
    //       title: 'Dashboard Tenant',
    //       requiresAuth: true,    //     }
    //   },
    //   {
    //     path: '/dashboard/provider',
    //     name: 'ProviderDashboard',
    //     component: () => import('@/components/dashboard/ProviderDashboard'),
    //     meta: {
    //       title: 'Dashboard Provider',
    //       requiresAuth: true,    //     }
    //   },
  }]
});

router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var profile;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!to.matched.some(function (record) {
              return record.meta.requiresAuth;
            })) {
              _context.next = 11;
              break;
            }

            if (!to.matched.some(function (record) {
              return record.meta.services !== undefined && record.meta.services.length > 0;
            })) {
              _context.next = 8;
              break;
            }

            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__store_index_js__["a" /* default */].dispatch("user/getProfile");

          case 4:
            profile = _context.sent;

            if (to.meta.services.some(function (service) {
              return profile.services[service];
            })) {
              next();
            } else {
              next("/unauthorized");
            }
            _context.next = 9;
            break;

          case 8:
            // authorization per-components
            next();

          case 9:
            _context.next = 12;
            break;

          case 11:
            // no auth required. We can navigate
            next();

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_authService_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_master_identity_identityUserService_js__ = __webpack_require__(254);





var _mutations,
    _this = this;







__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);

var PROFILE_KEY = "mavprofile";
var TOKEN_KEY = "mavtokenkey";
var USER_KEY = "mavuserkey";
var STORE_PROFILE = "STORE_PROFILE";
var REMOVE_PROFILE = "REMOVE_PROFILE";
var STORE_TOKEN = "STORE_TOKEN";
var REMOVE_TOKEN = "REMOVE_TOKEN";
var STORE_USER = "STORE_USER";
var REMOVE_USER = "REMOVE_USER";
var auth = new __WEBPACK_IMPORTED_MODULE_7__services_authService_js__["a" /* default */]();

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, STORE_PROFILE, function (state, profile) {
  var encodedProfile = btoa(unescape(encodeURIComponent(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(profile))));
  __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].set(PROFILE_KEY, encodedProfile, 300000); // 5 mins
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, REMOVE_PROFILE, function (state) {
  __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].remove(PROFILE_KEY);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, STORE_TOKEN, function (state, token) {
  var timeNow = new Date().getTime();
  var timeDiff = token.user.exp * 1000 - timeNow;
  var encodedToken = btoa(unescape(encodeURIComponent(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(token))));
  __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].set(TOKEN_KEY, encodedToken, timeDiff);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, REMOVE_TOKEN, function (state) {
  __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].remove(TOKEN_KEY);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, STORE_USER, function (state, user) {
  var timeNow = new Date().getTime();
  var timeDiff = user.exp * 1000 - timeNow;
  var encodedUser = btoa(unescape(encodeURIComponent(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(user))));
  __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].set(USER_KEY, encodedUser, timeDiff);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, REMOVE_USER, function (state) {
  __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].remove(USER_KEY);
}), _mutations);

var actions = {
  getUser: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
      var commit = _ref2.commit;
      var user, decodedUser;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              // get from cache
              user = __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].get(USER_KEY);

              if (!(user !== undefined && user !== null && user !== "")) {
                _context.next = 6;
                break;
              }

              decodedUser = JSON.parse(decodeURIComponent(escape(atob(user))));

              if (!decodedUser) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", decodedUser);

            case 6:

              // clean storage
              commit(REMOVE_USER);

              // get from API
              _context.next = 9;
              return auth.getUser();

            case 9:
              user = _context.sent;


              // store to local storage
              commit(STORE_USER, user);

              return _context.abrupt("return", user);

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);

              commit(REMOVE_USER);
              throw new Error(_context.t0);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 14]]);
    }));

    return function getUser(_x) {
      return _ref.apply(this, arguments);
    };
  }(),
  removeUser: function removeUser(_ref3) {
    var commit = _ref3.commit;

    try {
      // clean storage
      commit(REMOVE_USER);
    } catch (error) {
      throw new Error(error);
    }
  },
  getProfile: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit;
      var currentUser, profile, decodedProfile;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return dispatch("getUser");

            case 3:
              currentUser = _context2.sent;


              // get from cache
              profile = __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].get(PROFILE_KEY);

              if (!(profile && profile !== "")) {
                _context2.next = 9;
                break;
              }

              decodedProfile = JSON.parse(decodeURIComponent(escape(atob(profile))));

              if (!(decodedProfile && decodedProfile.id === currentUser.profile.sub)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", decodedProfile);

            case 9:

              // clean storage
              commit(REMOVE_PROFILE);

              // get from API
              _context2.next = 12;
              return __WEBPACK_IMPORTED_MODULE_8__services_master_identity_identityUserService_js__["a" /* default */].getProfile();

            case 12:
              profile = _context2.sent;

              commit(STORE_PROFILE, profile);

              return _context2.abrupt("return", profile);

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);

              commit(REMOVE_PROFILE);
              throw new Error(_context2.t0);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 17]]);
    }));

    return function getProfile(_x2) {
      return _ref4.apply(this, arguments);
    };
  }(),
  removeProfile: function removeProfile(_ref6) {
    var commit = _ref6.commit;

    try {
      // clean storage
      commit(REMOVE_PROFILE);
    } catch (error) {
      throw new Error(error);
    }
  },
  getToken: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8) {
      var commit = _ref8.commit;
      var accessToken, decodedAccessToken;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              // get from cache
              accessToken = __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].get(TOKEN_KEY);

              if (!(accessToken !== undefined && accessToken !== null && accessToken !== "")) {
                _context3.next = 6;
                break;
              }

              decodedAccessToken = JSON.parse(decodeURIComponent(escape(atob(accessToken))));

              if (!decodedAccessToken.token) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return", decodedAccessToken.token);

            case 6:

              // clean storage
              commit(REMOVE_TOKEN);

              // get from API
              _context3.next = 9;
              return auth.getAcessToken();

            case 9:
              accessToken = _context3.sent;


              // store to local storage
              commit(STORE_TOKEN, accessToken);

              return _context3.abrupt("return", accessToken.token);

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](0);

              commit(REMOVE_TOKEN);
              throw new Error(_context3.t0);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 14]]);
    }));

    return function getToken(_x3) {
      return _ref7.apply(this, arguments);
    };
  }(),
  removeToken: function removeToken(_ref9) {
    var commit = _ref9.commit;

    try {
      // clean storage
      commit(REMOVE_TOKEN);
    } catch (error) {
      throw new Error(error);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_master_setting_settingService__ = __webpack_require__(255);





var _mutations,
    _this = this;






__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);

var SETTING_KEY = "mavsetting";
var STORE_SETTING = "STORE_SETTING";
var REMOVE_SETTING = "REMOVE_SETTING";

var state = {
  transactionCurrency: null,
  showMultiCurrency: true,
  paymentStatus: null,
  reservationStatus: null
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, STORE_SETTING, function (state, setting) {
  var encodedSetting = btoa(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(setting));
  __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].set(SETTING_KEY, encodedSetting, 300000); // 5 mins
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, REMOVE_SETTING, function (state) {
  __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].remove(SETTING_KEY);
}), _mutations);

var actions = {
  getAllPublic: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
      var commit = _ref2.commit;
      var publicSettings;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              // get from cache
              publicSettings = __WEBPACK_IMPORTED_MODULE_6__plugins_cache_js__["a" /* default */].get(SETTING_KEY);

              if (!(publicSettings !== undefined && publicSettings !== null && publicSettings !== "")) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", JSON.parse(atob(publicSettings)));

            case 4:

              // clean storage
              commit(REMOVE_SETTING);

              // get from API
              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7__services_master_setting_settingService__["a" /* default */].getAllPublic();

            case 7:
              publicSettings = _context.sent;


              // store to local storage
              commit(STORE_SETTING, publicSettings);

              return _context.abrupt("return", publicSettings);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);

              commit(REMOVE_SETTING);
              throw new Error(_context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 12]]);
    }));

    return function getAllPublic(_x) {
      return _ref.apply(this, arguments);
    };
  }(),
  removeSetting: function removeSetting(_ref3) {
    var commit = _ref3.commit;

    try {
      // clean storage
      commit(REMOVE_SETTING);
    } catch (error) {
      throw new Error(error);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "/availability/inquiry",
  name: "InquiryAvailabilityResult",
  component: function component() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 386));
  },
  meta: {
    requiresAuth: true,
    services: ["InquiryAvailability"]
  }
}, {
  path: "/availability/instant",
  name: "InstantAvailabilityResult",
  component: function component() {
    return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 387));
  },
  meta: {
    requiresAuth: true,
    services: ["InstantAvailability"]
  }
}, {
  path: "/form/instant/:id",
  name: "InstantReservationForm",
  component: function component() {
    return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 388));
  },
  meta: {
    requiresAuth: true,
    services: ["InstantAvailability"]
  }
}, {
  path: "/form/inquiry/:id",
  name: "InquiryReservationForm",
  component: function component() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 389));
  },
  meta: {
    requiresAuth: true,
    services: ["InquiryAvailability"]
  }
}, {
  path: "/form/inquiry-rental/:id",
  name: "InquiryReservationFormRental",
  component: function component() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 390));
  },
  meta: {
    requiresAuth: true,
    services: ["InquiryAvailability"]
  }
}, {
  path: "/reservation/instant/:id",
  name: "InstantReservationSummary",
  component: function component() {
    return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 391));
  },
  meta: {
    requiresAuth: true,
    services: ["InstantAvailability", "InstantReservation"]
  }
}, {
  path: "/reservation/inquiry/:id",
  name: "InquiryReservationSummary",
  component: function component() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 392));
  },
  meta: {
    requiresAuth: true,
    services: ["InquiryAvailability", "InquiryReservation"]
  }
}, {
  path: "/reservation/tenant/trip-log/:id",
  name: "InquiryReservationLogging",
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 257));
  },
  meta: {
    requiresAuth: true,
    services: ["InquiryAvailability", "InquiryReservation"]
  }
}, {
  path: "/reservation/provider/trip-log/:id",
  name: "InquiryReservationLogging",
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 257));
  },
  meta: {
    requiresAuth: true,
    services: ["InquiryAvailability", "InquiryReservation"]
  }
}]);

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 92,
	"./af.js": 92,
	"./ar": 93,
	"./ar-dz": 94,
	"./ar-dz.js": 94,
	"./ar-kw": 95,
	"./ar-kw.js": 95,
	"./ar-ly": 96,
	"./ar-ly.js": 96,
	"./ar-ma": 97,
	"./ar-ma.js": 97,
	"./ar-sa": 98,
	"./ar-sa.js": 98,
	"./ar-tn": 99,
	"./ar-tn.js": 99,
	"./ar.js": 93,
	"./az": 100,
	"./az.js": 100,
	"./be": 101,
	"./be.js": 101,
	"./bg": 102,
	"./bg.js": 102,
	"./bm": 103,
	"./bm.js": 103,
	"./bn": 104,
	"./bn-bd": 105,
	"./bn-bd.js": 105,
	"./bn.js": 104,
	"./bo": 106,
	"./bo.js": 106,
	"./br": 107,
	"./br.js": 107,
	"./bs": 108,
	"./bs.js": 108,
	"./ca": 109,
	"./ca.js": 109,
	"./cs": 110,
	"./cs.js": 110,
	"./cv": 111,
	"./cv.js": 111,
	"./cy": 112,
	"./cy.js": 112,
	"./da": 113,
	"./da.js": 113,
	"./de": 114,
	"./de-at": 115,
	"./de-at.js": 115,
	"./de-ch": 116,
	"./de-ch.js": 116,
	"./de.js": 114,
	"./dv": 117,
	"./dv.js": 117,
	"./el": 118,
	"./el.js": 118,
	"./en-au": 119,
	"./en-au.js": 119,
	"./en-ca": 120,
	"./en-ca.js": 120,
	"./en-gb": 121,
	"./en-gb.js": 121,
	"./en-ie": 122,
	"./en-ie.js": 122,
	"./en-il": 123,
	"./en-il.js": 123,
	"./en-in": 124,
	"./en-in.js": 124,
	"./en-nz": 125,
	"./en-nz.js": 125,
	"./en-sg": 126,
	"./en-sg.js": 126,
	"./eo": 127,
	"./eo.js": 127,
	"./es": 128,
	"./es-do": 129,
	"./es-do.js": 129,
	"./es-mx": 130,
	"./es-mx.js": 130,
	"./es-us": 131,
	"./es-us.js": 131,
	"./es.js": 128,
	"./et": 132,
	"./et.js": 132,
	"./eu": 133,
	"./eu.js": 133,
	"./fa": 134,
	"./fa.js": 134,
	"./fi": 135,
	"./fi.js": 135,
	"./fil": 136,
	"./fil.js": 136,
	"./fo": 137,
	"./fo.js": 137,
	"./fr": 138,
	"./fr-ca": 139,
	"./fr-ca.js": 139,
	"./fr-ch": 140,
	"./fr-ch.js": 140,
	"./fr.js": 138,
	"./fy": 141,
	"./fy.js": 141,
	"./ga": 142,
	"./ga.js": 142,
	"./gd": 143,
	"./gd.js": 143,
	"./gl": 144,
	"./gl.js": 144,
	"./gom-deva": 145,
	"./gom-deva.js": 145,
	"./gom-latn": 146,
	"./gom-latn.js": 146,
	"./gu": 147,
	"./gu.js": 147,
	"./he": 148,
	"./he.js": 148,
	"./hi": 149,
	"./hi.js": 149,
	"./hr": 150,
	"./hr.js": 150,
	"./hu": 151,
	"./hu.js": 151,
	"./hy-am": 152,
	"./hy-am.js": 152,
	"./id": 153,
	"./id.js": 153,
	"./is": 154,
	"./is.js": 154,
	"./it": 155,
	"./it-ch": 156,
	"./it-ch.js": 156,
	"./it.js": 155,
	"./ja": 157,
	"./ja.js": 157,
	"./jv": 158,
	"./jv.js": 158,
	"./ka": 159,
	"./ka.js": 159,
	"./kk": 160,
	"./kk.js": 160,
	"./km": 161,
	"./km.js": 161,
	"./kn": 162,
	"./kn.js": 162,
	"./ko": 163,
	"./ko.js": 163,
	"./ku": 164,
	"./ku.js": 164,
	"./ky": 165,
	"./ky.js": 165,
	"./lb": 166,
	"./lb.js": 166,
	"./lo": 167,
	"./lo.js": 167,
	"./lt": 168,
	"./lt.js": 168,
	"./lv": 169,
	"./lv.js": 169,
	"./me": 170,
	"./me.js": 170,
	"./mi": 171,
	"./mi.js": 171,
	"./mk": 172,
	"./mk.js": 172,
	"./ml": 173,
	"./ml.js": 173,
	"./mn": 174,
	"./mn.js": 174,
	"./mr": 175,
	"./mr.js": 175,
	"./ms": 176,
	"./ms-my": 177,
	"./ms-my.js": 177,
	"./ms.js": 176,
	"./mt": 178,
	"./mt.js": 178,
	"./my": 179,
	"./my.js": 179,
	"./nb": 180,
	"./nb.js": 180,
	"./ne": 181,
	"./ne.js": 181,
	"./nl": 182,
	"./nl-be": 183,
	"./nl-be.js": 183,
	"./nl.js": 182,
	"./nn": 184,
	"./nn.js": 184,
	"./oc-lnc": 185,
	"./oc-lnc.js": 185,
	"./pa-in": 186,
	"./pa-in.js": 186,
	"./pl": 187,
	"./pl.js": 187,
	"./pt": 188,
	"./pt-br": 189,
	"./pt-br.js": 189,
	"./pt.js": 188,
	"./ro": 190,
	"./ro.js": 190,
	"./ru": 191,
	"./ru.js": 191,
	"./sd": 192,
	"./sd.js": 192,
	"./se": 193,
	"./se.js": 193,
	"./si": 194,
	"./si.js": 194,
	"./sk": 195,
	"./sk.js": 195,
	"./sl": 196,
	"./sl.js": 196,
	"./sq": 197,
	"./sq.js": 197,
	"./sr": 198,
	"./sr-cyrl": 199,
	"./sr-cyrl.js": 199,
	"./sr.js": 198,
	"./ss": 200,
	"./ss.js": 200,
	"./sv": 201,
	"./sv.js": 201,
	"./sw": 202,
	"./sw.js": 202,
	"./ta": 203,
	"./ta.js": 203,
	"./te": 204,
	"./te.js": 204,
	"./tet": 205,
	"./tet.js": 205,
	"./tg": 206,
	"./tg.js": 206,
	"./th": 207,
	"./th.js": 207,
	"./tk": 208,
	"./tk.js": 208,
	"./tl-ph": 209,
	"./tl-ph.js": 209,
	"./tlh": 210,
	"./tlh.js": 210,
	"./tr": 211,
	"./tr.js": 211,
	"./tzl": 212,
	"./tzl.js": 212,
	"./tzm": 213,
	"./tzm-latn": 214,
	"./tzm-latn.js": 214,
	"./tzm.js": 213,
	"./ug-cn": 215,
	"./ug-cn.js": 215,
	"./uk": 216,
	"./uk.js": 216,
	"./ur": 217,
	"./ur.js": 217,
	"./uz": 218,
	"./uz-latn": 219,
	"./uz-latn.js": 219,
	"./uz.js": 218,
	"./vi": 220,
	"./vi.js": 220,
	"./x-pseudo": 221,
	"./x-pseudo.js": 221,
	"./yo": 222,
	"./yo.js": 222,
	"./zh-cn": 223,
	"./zh-cn.js": 223,
	"./zh-hk": 224,
	"./zh-hk.js": 224,
	"./zh-mo": 225,
	"./zh-mo.js": 225,
	"./zh-tw": 226,
	"./zh-tw.js": 226
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 307;

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/onboarding',
  name: 'OnBoarding',
  component: function component() {
    return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 393));
  },
  meta: {
    title: 'Provider Candidate',
    requiresAuth: true,
    services: ['OnBoarding']
  }
}]);

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
// {
//   path: '/report/instant',
//   name: 'InstantReport',
//   component: () => import('@/components/reservation/instant/ReservationReport'),
//   meta: {
//     title: 'Instant Report',
//     requiresAuth: true,
//     services: ['InstantReport']
//   }
// },
{
  path: '/report/tenant',
  name: 'TenantReport',
  component: function component() {
    return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 394));
  },
  meta: {
    title: 'Tenant Report',
    requiresAuth: true,
    services: ['TenantReport']
  }
}, {
  path: '/report/provider',
  name: 'ProviderReport',
  component: function component() {
    return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 395));
  },
  meta: {
    title: 'Provider Report',
    requiresAuth: true,
    services: ['ProviderReport']
  }
}, {
  path: '/report/customer',
  name: 'CustomerReport',
  component: function component() {
    return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 396));
  },
  meta: {
    title: 'Customer Report',
    requiresAuth: true,
    services: ['CustomerReport']
  }
}]);

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "/job/available",
  name: "AvailableJob",
  component: function component() {
    return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 397));
  },
  meta: {
    title: "Pending Job Browser",
    requiresAuth: true,
    services: ["AvailableJob"]
  }
}, {
  path: "/job/available/:id",
  name: "AvailableJobDetail",
  component: function component() {
    return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 398));
  },
  meta: {
    requiresAuth: true,
    services: ["AvailableJob"]
  }
}, {
  path: "/job/tenant",
  name: "TenantJob",
  component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 399));
  },
  meta: {
    title: "Tenant Job Browser",
    requiresAuth: true,
    services: ["TenantJob"]
  }
}, {
  path: "/job/tenant/:id",
  name: "TenantJobDetail",
  component: function component() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 400));
  },
  meta: {
    requiresAuth: true,
    services: ["TenantJob"]
  }
}, {
  path: "/job/tenant/repricing/:id",
  name: "Repricing",
  component: function component() {
    return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 401));
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: "/job/provider",
  name: "ProviderJob",
  component: function component() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 402));
  },
  meta: {
    title: "Provider Job Browser",
    requiresAuth: true,
    services: ["ProviderJob"]
  }
}, {
  path: "/job/provider/:id",
  name: "ProviderJobDetail",
  component: function component() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 403));
  },
  meta: {
    requiresAuth: true,
    services: ["ProviderJob"]
  }
}, {
  path: "/job/provider/invoice/:id",
  name: "ProviderJobInvoice",
  component: function component() {
    return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 404));
  },
  meta: {
    requiresAuth: true,
    services: ["ProviderJob"]
  }
}, {
  path: "/job/driver",
  name: "DriverJob",
  component: function component() {
    return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 405));
  },
  meta: {
    title: "Driver Job Browser",
    requiresAuth: true,
    services: ["DriverJob"]
  }
}, {
  path: "/job/driver/:id",
  name: "DriverJobDetail",
  component: function component() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 406));
  },
  meta: {
    requiresAuth: true,
    services: ["DriverJob"]
  }
}]);

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "/fleet/provider",
  name: "Provider",
  component: function component() {
    return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 407));
  },
  meta: {
    title: "Provider",
    requiresAuth: true,
    services: ["Provider"]
  }
}, {
  path: "/fleet/driver",
  name: "Driver",
  component: function component() {
    return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 408));
  },
  meta: {
    title: "Driver",
    requiresAuth: true,
    services: ["Driver"]
  }
}, {
  path: "/fleet/driver-tracker",
  name: "DriverTracker",
  component: function component() {
    return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 409));
  },
  meta: {
    title: "Driver Tracker",
    requiresAuth: true,
    services: ["Driver"]
  }
}, {
  path: "/fleet/vehicle",
  name: "Vehicle",
  component: function component() {
    return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 410));
  },
  meta: {
    title: "Vehicle",
    requiresAuth: true,
    services: ["Vehicle"]
  }
}, {
  path: "/fleet/class",
  name: "MasterClass",
  component: function component() {
    return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 411));
  },
  meta: {
    title: "Master Class",
    requiresAuth: true,
    services: ["MasterClass"]
  }
}, {
  path: "/fleet/maintenance",
  name: "VehicleRepairement",
  component: function component() {
    return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 412));
  },
  meta: {
    title: "Vehicle Maintenance",
    requiresAuth: true,
    services: ["VehicleRepairement"]
  }
}]);

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/geofence',
  name: 'Zone',
  component: function component() {
    return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 413));
  },
  meta: {
    title: 'Zone',
    requiresAuth: true,
    services: ['Zone']
  }
}]);

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
// {
//   path: '/buying/ancillary',
//   name: 'BuyingTariffAncillaryRate',
//   component: () => import('@/components/master/buyingTariff/AncillaryRate'),
//   meta: {
//     title: 'Operator Tariff - Ancillary Rate',
//     requiresAuth: true,
//     services: ['BuyingTariffAncillaryRate']
//   }
// },
{
  path: "/buying/chauffeur",
  name: "BuyingTariffRentalChauffeurRate",
  component: function component() {
    return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 414));
  },
  meta: {
    title: "Operator Tariff - Chauffeur Rate",
    requiresAuth: true,
    services: ["BuyingTariffRentalChauffeurRate"]
  }
}, {
  path: "/buying/hourly-chauffeur",
  name: "BuyingTariffRentalChauffeurRate",
  component: function component() {
    return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 415));
  },
  meta: {
    title: "Operator Tariff - Chauffeur Rate",
    requiresAuth: true,
    services: ["BuyingTariffRentalChauffeurRate"]
  }
}, {
  path: "/buying/hourly-chauffeur/:masterClassId",
  name: "BuyingTariffRentalChauffeurRate",
  component: function component() {
    return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 416));
  },
  meta: {
    title: "Operator Tariff - Chauffeur Rate",
    requiresAuth: true,
    services: ["BuyingTariffRentalChauffeurRate"]
  }
}, {
  path: "/buying/selfdrive",
  name: "BuyingTariffRentalSelfDriveRate",
  component: function component() {
    return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 417));
  },
  meta: {
    title: "Operator Tariff - Self Drive Rate",
    requiresAuth: true,
    services: ["BuyingTariffRentalSelfDriveRate"]
  }
},
// {
//   path: "/buying/transfer",
//   name: "BuyingTariffTransferRate",
//   component: () => import("@/components/master/buyingTariff/TransferRate"),
//   meta: {
//     title: "Operator Tariff - Transfer Rate",
//     requiresAuth: true,
//     services: ["BuyingTariffTransferRate"]
//   }
// },
{
  path: "/buying/transfer",
  name: "BuyingTariffTransferRate",
  component: function component() {
    return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 418));
  },
  meta: {
    title: "Operator Tariff - Transfer Rate",
    requiresAuth: true,
    services: ["BuyingTariffTransferRate"]
  }
}, {
  path: "/buying/transfer/:masterClassId",
  name: "BuyingTariffTransferRate",
  component: function component() {
    return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 419));
  },
  meta: {
    title: "Operator Tariff - Transfer Rate",
    requiresAuth: true,
    services: ["BuyingTariffTransferRate"]
  }
}, {
  path: "/buying/surcharge",
  name: "BuyingTariffSurcharge",
  component: function component() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 420));
  },
  meta: {
    title: "Operator Tariff - Surcharge",
    requiresAuth: true,
    services: ["BuyingTariffGeneralSurcharge", "BuyingTariffCancellationSurcharge", "BuyingTariffPeakPeriodSurcharge", "BuyingTariffWaitingTimeSurcharge"]
  }
}, {
  path: "/buying/chauffeur/override",
  name: "BuyingTariffOverriddenRentalChauffeurRate",
  component: function component() {
    return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 421));
  },
  meta: {
    title: "Operator Tariff - Overridden Chauffeur Rate",
    requiresAuth: true,
    services: ["BuyingTariffOverriddenRentalChauffeurRate"]
  }
}, {
  path: "/buying/selfdrive/override",
  name: "BuyingTariffOverriddenRentalSelfDriveRate",
  component: function component() {
    return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 422));
  },
  meta: {
    title: "Operator Tariff - Overridden Self Drive Rate",
    requiresAuth: true,
    services: ["BuyingTariffOverriddenRentalSelfDriveRate"]
  }
}, {
  path: "/buying/transfer/override",
  name: "BuyingTariffOverriddenTransferRate",
  component: function component() {
    return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 423));
  },
  meta: {
    title: "Operator Tariff - Overridden Transfer Rate",
    requiresAuth: true,
    services: ["BuyingTariffOverriddenTransferRate"]
  }
}, {
  path: "/buying/surcharge/override",
  name: "BuyingTariffOverriddenSurcharge",
  component: function component() {
    return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 424));
  },
  meta: {
    title: "Operator Tariff - Overridden Surcharge",
    requiresAuth: true,
    services: ["BuyingTariffOverriddenGeneralSurcharge", "BuyingTariffOverriddenCancellationSurcharge", "BuyingTariffOverriddenPeakPeriodSurcharge", "BuyingTariffOverriddenWaitingTimeSurcharge"]
  }
}]);

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "/selling/ancillary",
  name: "SellingTariffAncillaryRate",
  component: function component() {
    return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 425));
  },
  meta: {
    title: "Booker Tariff - Ancillary Rate",
    requiresAuth: true,
    services: ["SellingTariffAncillaryRate"]
  }
}, {
  path: "/selling/chauffeur",
  name: "SellingTariffRentalChauffeurRate",
  component: function component() {
    return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 426));
  },
  meta: {
    title: "Booker Tariff - Chauffeur Rate",
    requiresAuth: true,
    services: ["SellingTariffRentalChauffeurRate"]
  }
}, {
  path: "/selling/hourly-chauffeur",
  name: "SellingTariffRentalChauffeurRate",
  component: function component() {
    return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 427));
  },
  meta: {
    title: "Booker Tariff - Chauffeur Rate",
    requiresAuth: true,
    services: ["SellingTariffRentalChauffeurRate"]
  }
}, {
  path: "/selling/hourly-chauffeur/:masterClassId",
  name: "SellingTariffRentalChauffeurRate",
  component: function component() {
    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 428));
  },
  meta: {
    title: "Booker Tariff - Chauffeur Rate",
    requiresAuth: true,
    services: ["SellingTariffRentalChauffeurRate"]
  }
}, {
  path: "/selling/selfdrive",
  name: "SellingTariffRentalSelfDriveRate",
  component: function component() {
    return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 429));
  },
  meta: {
    title: "Booker Tariff - Self Drive Rate",
    requiresAuth: true,
    services: ["SellingTariffRentalSelfDriveRate"]
  }
},
// {
//   path: "/selling/transfer",
//   name: "SellingTariffTransferRate",
//   component: () => import("@/components/master/sellingTariff/TransferRate"),
//   meta: {
//     title: "Booker Tariff - Transfer Rate",
//     requiresAuth: true,
//     services: ["SellingTariffTransferRate"]
//   }
// },
{
  path: "/selling/transfer",
  name: "SellingTariffTransferRate",
  component: function component() {
    return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 430));
  },
  meta: {
    title: "Booker Tariff - Transfer Rate",
    requiresAuth: true,
    services: ["SellingTariffTransferRate"]
  }
}, {
  path: "/selling/transfer/:masterClassId",
  name: "SellingTariffTransferRate",
  component: function component() {
    return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 431));
  },
  meta: {
    title: "Booker Tariff - Transfer Rate",
    requiresAuth: true,
    services: ["SellingTariffTransferRate"]
  }
}, {
  path: "/selling/surcharge",
  name: "SellingTariffSurcharge",
  component: function component() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 432));
  },
  meta: {
    title: "Booker Tariff - Surcharge",
    requiresAuth: true,
    services: ["SellingTariffGeneralSurcharge", "SellingTariffCancellationSurcharge", "SellingTariffPeakPeriodSurcharge", "SellingTariffWaitingTimeSurcharge"]
  }
}, {
  path: "/selling/markup",
  name: "SellingTariffMarkup",
  component: function component() {
    return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 433));
  },
  meta: {
    title: "Booker Tariff - Markup",
    requiresAuth: true,
    services: ["SellingTariffMarkup"]
  }
}, {
  path: "/selling/incentive",
  name: "SellingTariffIncentive",
  component: function component() {
    return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 434));
  },
  meta: {
    title: "Booker Tariff - Incentive",
    requiresAuth: true,
    services: ["SellingTariffIncentive"]
  }
}, {
  path: "/selling/company-incentive",
  name: "SellingTariffIncentiveCompany",
  component: function component() {
    return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 435));
  },
  meta: {
    title: "Booker Tariff - Company Incentive",
    requiresAuth: true,
    services: ["SellingTariffIncentiveCompany"]
  }
}]);

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/corporate/company',
  name: 'Company',
  component: function component() {
    return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 436));
  },
  meta: {
    title: 'Company',
    requiresAuth: true,
    services: ['Company']
  }
}, {
  path: '/corporate/customer',
  name: 'Customer',
  component: function component() {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 437));
  },
  meta: {
    title: 'Customer',
    requiresAuth: true,
    services: ['Customer']
  }
}]);

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "/finance/invoice",
  name: "Invoice",
  component: function component() {
    return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 438));
  },
  meta: {
    title: "Finance - Invoice",
    requiresAuth: true,
    services: ["InquiryReservation"]
  }
}, {
  path: "/finance/invoice/receive-payment",
  name: "Invoice",
  component: function component() {
    return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 439));
  },
  meta: {
    title: "Finance - Receive Payment",
    requiresAuth: true,
    services: ["InquiryReservation"]
  }
}, {
  path: "/finance/invoice/edit-invoice/:id",
  name: "Invoice",
  component: function component() {
    return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 440));
  },
  meta: {
    title: "Finance - Edit Invoice",
    requiresAuth: true,
    services: ["InquiryReservation"]
  }
}, {
  path: "/finance/invoice-detail/:invoice_id/:reservation_id",
  name: "Invoice",
  component: function component() {
    return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 441));
  },
  meta: {
    title: "Finance - Invoice Detail",
    requiresAuth: true,
    services: ["InquiryReservation"]
  }
}]);

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "/administration/setting",
  name: "Setting",
  component: function component() {
    return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 442));
  },
  meta: {
    title: "Global Setting",
    requiresAuth: true,
    services: ["Setting"]
  }
}, {
  path: "/administration/setting/term-conditions-form",
  name: "Term - Conditions",
  component: function component() {
    return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 443));
  },
  meta: {
    title: "Term & Conditions",
    requiresAuth: true,
    services: ["Setting"]
  }
}, {
  path: "/administration/peak-period",
  name: "PeakPeriod",
  component: function component() {
    return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 444));
  },
  meta: {
    title: "Peak Period",
    requiresAuth: true,
    services: ["PeakPeriod"]
  }
}, {
  path: "/administration/pickup-offset",
  name: "PickUpOffset",
  component: function component() {
    return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 445));
  },
  meta: {
    title: "PickUp Offset",
    requiresAuth: true,
    services: ["Region"]
  }
}, {
  path: "/administration/rate-tagging",
  name: "Tagging",
  component: function component() {
    return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 446));
  },
  meta: {
    title: "Rate Tagging",
    requiresAuth: true,
    services: ["Region"]
  }
}]);

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/security/user',
  name: 'IdentityUser',
  component: function component() {
    return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 447));
  },
  meta: {
    title: 'Identity User',
    requiresAuth: true,
    services: ['IdentityUser']
  }
}, {
  path: '/security/role',
  name: 'IdentityRole',
  component: function component() {
    return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 448));
  },
  meta: {
    title: 'Identity Role',
    requiresAuth: true,
    services: ['IdentityRole']
  }
}, {
  path: '/security/permission',
  name: 'IdentityPolicy',
  component: function component() {
    return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 449));
  },
  meta: {
    title: 'Identity Permission',
    requiresAuth: true,
    services: ['IdentityPolicy']
  }
}]);

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/payment/credit/back',
  name: 'PaymentCreditBack',
  component: function component() {
    return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 450));
  },
  meta: {
    requiresAuth: true,
    services: []
  }
}, {
  path: '/payment/credit/redirect',
  name: 'PaymentCreditRedirect',
  component: function component() {
    return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 451));
  },
  meta: {
    requiresAuth: true,
    services: []
  }
}, {
  path: '/payment/deposit/redirect',
  name: 'PaymentDepositRedirect',
  component: function component() {
    return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 452));
  },
  meta: {
    requiresAuth: true,
    services: []
  }
}, {
  path: '/payment/credit/amend-redirect',
  name: 'AmendPaymentCreditRedirect',
  component: function component() {
    return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 453));
  },
  meta: {
    requiresAuth: false,
    services: []
  }
}]);

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);

var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  $on: function $on() {
    bus.$on.apply(bus, arguments);
  },
  $off: function $off() {
    bus.$off.apply(bus, arguments);
  },
  $once: function $once() {
    bus.$once.apply(bus, arguments);
  },
  $emit: function $emit() {
    bus.$emit.apply(bus, arguments);
  }
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
  collapseMenu: function collapseMenu(selector) {
    // reset 'open-menu' from all nav items
    document.querySelectorAll(".nav-parent").forEach(function (element) {
      return element.classList.remove("open-menu");
    });

    if (selector) {
      var nav = document.getElementById(selector);
      if (nav && nav.classList) {
        nav.classList.add("open-menu");
      }
    }
  },
  setNavigationClass: function setNavigationClass(selector) {
    // reset 'isActive' from all nav items
    document.querySelectorAll(".nav-master").forEach(function (element) {
      return element.classList.remove("isActive");
    });

    if (selector) {
      // add 'isActive' inside anchor element
      var nav = document.getElementById(selector);
      if (nav && nav.classList) {
        nav.classList.add("isActive");
      }
    }

    // hide nav panel
    var navPanel = document.getElementsByClassName("left-menu");
    if (navPanel) {
      navPanel[0].classList.remove("isActive");
    }

    // hide overlay from screen
    document.getElementsByClassName("overlay")[0].setAttribute("style", "display: none;");
  },
  fixDateTime: function fixDateTime(stringDate) {
    var result = null;
    if (stringDate !== null && stringDate !== undefined && stringDate !== "") {
      var periods = stringDate.split("-");
      result = {
        year: parseInt(periods[0]),
        month: parseInt(periods[1]),
        day: parseInt(periods[2])
      };
    }
    return result;
  },
  addDays: function addDays(days) {
    var date = new Date();
    date.setDate(date.getDate() + days);
    return date;
  },
  addMonths: function addMonths(month) {
    var date = new Date();
    date.setMonth(date.getMonth() + month);
    return date;
  },
  toStringDate: function toStringDate(date) {
    return date.getFullYear() + "-" + (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
  },
  validateForm: function validateForm(component, form, skipReset) {
    var self = this;
    var nodes = document.querySelectorAll("#" + form + " :invalid");
    var error = "validationErrors";
    var isSuccess = true;
    if (!skipReset) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(component[error]).forEach(function (key) {
        component[error][key] = null;
      });
    }
    if (nodes.length > 0) {
      nodes.forEach(function (node) {
        if (node.title) {
          component[error][node.name] = node.title;
        } else {
          component[error][node.name] = node.validationMessage;
        }
        node.addEventListener("change", function (e) {
          self.validateForm(component, form);
        });
      });
      isSuccess = false;
    }
    return isSuccess;
  },
  isEmpty: function isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  },
  redirectToServerError: function redirectToServerError(component) {
    component.$router.push({
      name: "500"
    });
  },
  toJavascriptDateTime: function toJavascriptDateTime(stringDateTime) {
    if (stringDateTime === undefined) {
      return null;
    }
    var rawDateTimes = stringDateTime.split("-"); // yyyy.MM.dd-HH.mm
    var dates = rawDateTimes[0].split("."); // yyyy.MM.dd
    var times = rawDateTimes[1].split("."); // HH.mm
    return new Date(parseInt(dates[0]), parseInt(dates[1]), parseInt(dates[2]), parseInt(times[0]), parseInt(times[1]), 0);
  },
  toMaverickDateTime: function toMaverickDateTime(stringDateTime) {
    if (stringDateTime === undefined) {
      return null;
    }
    var rawDateTimes = stringDateTime.split("-"); // yyyy.MM.dd-HH.mm
    var dates = rawDateTimes[0].split("."); // yyyy.MM.dd
    var times = rawDateTimes[1].split("."); // HH.mm
    return {
      year: parseInt(dates[0]),
      month: parseInt(dates[1]),
      day: parseInt(dates[2]),
      hour: parseInt(times[0]),
      minute: parseInt(times[1])
    };
  },
  toDateString: function toDateString(maverickDateTime, format) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(maverickDateTime.year, maverickDateTime.month - 1, maverickDateTime.day, maverickDateTime.hour, maverickDateTime.minute)).format(format);
  },
  alphabetsOnly: function alphabetsOnly() {
    var alphabetElements = document.getElementsByClassName("alphabets-only");
    for (var i = 0; i < alphabetElements.length; i++) {
      alphabetElements[i].addEventListener("keypress", function () {
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!new RegExp("^[a-zA-Z ]+$").test(key)) {
          event.preventDefault();
          return false;
        }
      });
    }
  },
  alphabetsCharactersOnly: function alphabetsCharactersOnly() {
    var alphabetElements = document.getElementsByClassName("alphabets-characters-only");
    for (var i = 0; i < alphabetElements.length; i++) {
      alphabetElements[i].addEventListener("keypress", function () {
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        // if (!new RegExp("^[a-zA-Z ]+$").test(key)) {
        if (!new RegExp("^[a-zA-Z .'\\/-]+$").test(key)) {
          event.preventDefault();
          return false;
        }
      });
    }
  },

  // numbersOnly() {
  //   const numericElements = document.getElementsByClassName("numbers-only");
  //   for (let i = 0; i < numericElements.length; i++) {
  //     numericElements[i].addEventListener("keypress", function() {
  //       const key = String.fromCharCode(
  //         !event.charCode ? event.which : event.charCode
  //       );
  //       if (!new RegExp("^[0-9]+$").test(key)) {
  //         event.preventDefault();
  //         return false;
  //       }
  //     });
  //   }
  // },
  numbersOnly: function numbersOnly() {
    var numericElements = document.getElementsByClassName("numbers-only");
    for (var i = 0; i < numericElements.length; i++) {
      numericElements[i].addEventListener("keypress", function (event) {
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);

        var currentValue = this.value;
        var newValue = currentValue + key;
        var regex = /^[0-9]+$/;

        if (!regex.test(newValue)) {
          event.preventDefault();
          return false;
        }
      });

      numericElements[i].addEventListener("input", function (event) {
        this.value = this.value.replace(/[^0-9]/g, "");
      });
    }
  },
  numbersCurrency: function numbersCurrency() {
    var numericElements = document.getElementsByClassName("numbers-currency");
    for (var i = 0; i < numericElements.length; i++) {
      numericElements[i].addEventListener("keypress", function (event) {
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);

        var currentValue = this.value;
        var newValue = currentValue + key;
        var regex = /^-?[0-9]*[.,]?[0-9]*$/;

        if (!regex.test(newValue)) {
          event.preventDefault();
          return false;
        }
      });

      numericElements[i].addEventListener("input", function (event) {
        var value = this.value;

        var parts = value.split(/[.,]/);
        if (parts.length > 2) {
          this.value = parts[0] + "." + parts.slice(1).join("");
        }

        if (value.indexOf("-") > 0) {
          this.value = value.replace(/-/g, "");
        }
        this.value = this.value.replace(/(?!^)-/g, "");
      });
    }
  },
  alphabetsNumbersOnly: function alphabetsNumbersOnly() {
    var alphabetElements = document.getElementsByClassName("alphabets-numbers-only");
    for (var i = 0; i < alphabetElements.length; i++) {
      alphabetElements[i].addEventListener("keypress", function () {
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!new RegExp("[a-zA-Z0-9]").test(key)) {
          event.preventDefault();
          return false;
        }
      });
    }
  },
  disableContextMenu: function disableContextMenu(element) {
    $(element).on("contextmenu", function (_) {
      return false;
    });
  },
  getPlaceIcon: function getPlaceIcon(types) {
    var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    switch (true) {
      case types.includes("airport") || description.toLowerCase().includes("airport"):
        return "<i class='ic-flight-landing'></i>";
      case types.includes("restaurant"):
      case types.includes("food"):
      case types.includes("cafe"):
        return "<i class='ic-meal'></i>";
      case types.includes("store"):
      case types.includes("shopping_mall"):
        return "<i class='ic-briefcase'></i>";
      case types.includes("lodging"):
        return "<i class='ic-bed'></i>";
      case types.includes("bus_station"):
        return "<i class='ic-bus'></i>";
      case types.includes("train_station"):
      case types.includes("transit_station"):
        return "<i class='ic-train'></i>";
      case types.includes("school"):
      case types.includes("university"):
      case types.includes("hospital"):
        return "<i class='ic-office'></i>";
      case types.includes("gym"):
        return "<i class='ic-fitness'></i>";
      default:
        return "<i class='ic-marker-maps'></i>";
    }
  },
  humanize: function humanize(text) {
    if (text && text !== "") {
      var formattedText = text.replace(/([A-Z])/g, " $1");
      var result = formattedText.charAt(0).toUpperCase() + formattedText.slice(1);
      return result.trim();
    }
    return text;
  },
  printFileSize: function printFileSize(size) {
    if (size < 1000000) {
      return (size / 1000).toFixed(0) + " KB";
    } else {
      return (size / 1000000).toFixed(2) + " MB";
    }
  },
  extractSetting: function extractSetting(items, key, defaultValue) {
    if (defaultValue === undefined) {
      defaultValue = null;
    }
    try {
      var setting = items.find(function (x) {
        return x.key === key;
      });
      return setting ? setting.value : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  },
  emptyGuid: function emptyGuid() {
    return "00000000-0000-0000-0000-000000000000";
  },
  getEventDescription: function getEventDescription(history) {
    var userType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Unspecified";

    var historyStrings = [];

    // append creator name
    if (history.createdBy && history.createdBy !== "" && userType === "TenantUser") {
      historyStrings.push("User: " + history.createdBy);
    }

    // display provider/vehicle/driver/passenger
    if (history.event.toLowerCase().includes("providerfullyconfirmed") && history.provider) {
      if (history.provider) {
        historyStrings.push("Provider: " + history.provider.name);
      }
      if (history.driver) {
        historyStrings.push("Driver: " + (history.driver.title ? history.driver.title : "") + " " + (history.driver.fullName ? history.driver.fullName : ""));
      }
      if (history.vehicle) {
        historyStrings.push("Vehicle: " + (history.vehicle.factoryName ? history.vehicle.factoryName : "") + " " + (history.vehicle.brandName ? history.vehicle.brandName : ""));
      }
    } else if (history.event.toLowerCase().includes("provider") && history.provider) {
      historyStrings.push("Provider: " + history.provider.name);
    } else if (history.event.toLowerCase().includes("driver") && history.driver) {
      historyStrings.push("Driver: " + (history.driver.title ? history.driver.title : "") + ". " + (history.driver.fullName ? history.driver.fullName : ""));
    } else if (history.event.toLowerCase().includes("vehicle") && history.vehicle) {
      historyStrings.push("Vehicle: " + (history.vehicle.factoryName ? history.vehicle.factoryName : "") + " " + (history.vehicle.brandName ? history.vehicle.brandName : ""));
    } else if (history.event.toLowerCase().includes("passenger") && history.customer) {
      historyStrings.push("Passenger: " + (history.customer.title ? history.customer.title : "") + " " + (history.customer.fullName ? history.customer.fullName : ""));
    }

    // append description
    if (history.description && history.description !== "") {
      // temp comment
      // let descriptionSplit = history.description.split("/");
      // let description = descriptionSplit[descriptionSplit.length - 1];
      if (history.event.toLowerCase() === "paid") {
        historyStrings.push("<span style=\"word-break: break-word;\">" + history.description + "</span>");
      } else if (userType !== "CorporateUser") {
        historyStrings.push("Description: <span style=\"word-break: break-word;\">" + history.description + "</span>");
      }
    }

    var result = "";
    for (var i = 0; i < historyStrings.length; i++) {
      var item = historyStrings[i];
      result += item;
      if (i < historyStrings.length - 1) {
        result += "<br/>";
      }
    }

    return result;
  },
  fromMinutestoMilliseconds: function fromMinutestoMilliseconds(minutes) {
    return minutes * 60000;
  },
  scrollTop: function scrollTop() {
    document.documentElement.scrollTop = 0;
  },
  focusToFieldError: function focusToFieldError() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var fieldError = form ? form.querySelector(".field-error") : document.querySelector(".field-error");

    if (fieldError) {
      fieldError.scrollIntoView({ behavior: "smooth" });
    }
  },
  prependToArray: function prependToArray(value, array) {
    var newArray = array.slice();
    newArray.unshift(value);
    return newArray;
  },
  isNotExpiredDate: function isNotExpiredDate(utcPickUpDateTimeOffset) {
    var _datetimeOffsetDiff = Date.parse(utcPickUpDateTimeOffset) - Date.parse(new Date().toUTCString());
    return _datetimeOffsetDiff >= 0;
  },
  printServiceType: function printServiceType(type) {
    switch (type) {
      case 1:
        return "Transfer";

      case 2:
        return "Rental";

      default:
        return "Unspecified";
    }
  },
  printRangeOfHour: function printRangeOfHour(start, end) {
    if (start === 0) {
      if (end === 0) {
        return "-";
      }
      return "Less than " + end + " hours";
    } else {
      if (end === null || end === -1) {
        return start + " hours or more";
      } else {
        return start + " hours and " + end + " hours";
      }
    }
  },
  printWaitingTimeSourceType: function printWaitingTimeSourceType(type) {
    switch (type) {
      case 1:
        return "Airport Arrival";

      case 2:
        return "Non-Airport Arrival";

      case 3:
        return "Extra Stop";

      case 4:
        return "Extra Stop Waiting Time";

      default:
        return "Unspecified";
    }
  },
  formatDateTime: function formatDateTime(date) {
    var optionDay = {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric"
    };
    var dates = new Intl.DateTimeFormat("en-GB", optionDay).format(date);
    var minutes = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
    var hour = date.getHours();

    return dates + " " + hour + ":" + minutes;
  },
  dateUKFormatted: function dateUKFormatted(inputDate) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(inputDate).parseZone().format("D/MM/YYYY");
  },
  dateFormatted: function dateFormatted(inputDate) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(inputDate).parseZone().format("MMMM D, YYYY");
  },
  timeFormatted: function timeFormatted(inputTime) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(inputTime).parseZone().format("HH:mm");
  },
  timeFormattedFull: function timeFormattedFull(inputTime) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(inputTime).parseZone().format("HH:mm:ss");
  },
  printAddressName: function printAddressName(address) {
    var firstAddress = address.split(",")[0];
    return firstAddress;
  }
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73652927_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(342);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73652927_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('BlockUI',{attrs:{"message":_vm.content}},[_c('div',{staticClass:"box__loader"},[_c('div',{staticClass:"loader--dot"}),_vm._v(" "),_c('div',{staticClass:"loader--dot"}),_vm._v(" "),_c('div',{staticClass:"loader--dot"})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 381:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_user__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_setting__ = __webpack_require__(304);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__store_modules_user__["a" /* default */],
    setting: __WEBPACK_IMPORTED_MODULE_3__store_modules_setting__["a" /* default */]
  }
}));

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return tryParseFloat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return tryParseInt; });
/* unused harmony export distribution */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertFromMarketFx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toHoursAndMinutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return currencyFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateDropOffDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertDateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return extractTextAfterGMT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_constants__ = __webpack_require__(237);




var tryParseFloat = function tryParseFloat(v) {
  var _float = parseFloat(v);
  return isNaN(_float) ? null : _float;
};

var tryParseInt = function tryParseInt(v) {
  var _int = parseInt(v);
  return isNaN(_int) ? null : _int;
};

var distribution = function distribution(originalCurrency, localCurrency) {
  return originalCurrency / localCurrency;
};

var convertFromMarketFx = function convertFromMarketFx(amount, conversionRate, conversionFormula) {
  if (conversionFormula.toLowerCase() === __WEBPACK_IMPORTED_MODULE_2__models_constants__["d" /* ConversionFormula */].MultiplicationValue.toLowerCase()) {
    return amount / conversionRate;
  }
  return amount * conversionRate;
};

var toHoursAndMinutes = function toHoursAndMinutes(totalMinutes) {
  var hours = Math.floor(totalMinutes / 60);
  var minutes = totalMinutes % 60;
  return { hours: hours, minutes: minutes };
};

var currencyFormat = function currencyFormat(currencyCode, currencyValue) {
  var ccyFormat = __WEBPACK_IMPORTED_MODULE_2__models_constants__["e" /* CurrencyFormat */].find(function (val) {
    return val.Currency === currencyCode;
  });

  if (ccyFormat) {
    if (ccyFormat.DecimalPoint === 0) {
      return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(Math.ceil(currencyValue)).format(ccyFormat.Format);
    }

    return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.round(currencyValue, ccyFormat.DecimalPoint)).format(ccyFormat.Format);
  }

  return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.round(currencyValue, 2)).format(0, 0.0);
};

var calculateDropOffDate = function calculateDropOffDate(date) {
  var combinedDateTime = new Date(date.date + "T" + date.time + ":00");
  var pickUpDate = new Date(combinedDateTime);
  var dropOffDate = new Date(combinedDateTime);
  var duration = date.durationInHour * 60;
  dropOffDate.setMinutes(dropOffDate.getMinutes() + duration);

  var resPickUpDate = {
    year: pickUpDate.getFullYear(),
    month: pickUpDate.getMonth() + 1,
    day: pickUpDate.getDate(),
    hour: pickUpDate.getHours(),
    minute: pickUpDate.getMinutes()
  };

  var resDropOffDate = {
    year: dropOffDate.getFullYear(),
    month: dropOffDate.getMonth() + 1,
    day: dropOffDate.getDate(),
    hour: dropOffDate.getHours(),
    minute: dropOffDate.getMinutes()
  };
  return { pickUp: resPickUpDate, dropOff: resDropOffDate };
};

var convertDateTime = function convertDateTime(inputDate) {
  var dateParts = inputDate.date.split("-");
  var timeParts = inputDate.time.split(":");

  var outputDate = {
    year: parseInt(dateParts[0], 10),
    month: parseInt(dateParts[1], 10),
    day: parseInt(dateParts[2], 10),
    hour: parseInt(timeParts[0], 10),
    minute: parseInt(timeParts[1], 10),
    second: 0
  };

  return outputDate;
};

var extractTextAfterGMT = function extractTextAfterGMT(dateString) {
  var startIndex = dateString.indexOf("GMT") + 3;
  return Number(dateString.slice(startIndex).trim());
};

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app"
});

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  set: function set(key, value, ttl) {
    // `item` is an object which contains the original value as well as the time when it's supposed to expire
    var item = {
      value: value,
      expiry: new Date().getTime() + ttl
    };
    localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
  },
  get: function get(key) {
    var stringItem = localStorage.getItem(key);

    // if the item doesn't exist, return null
    if (!stringItem) {
      return null;
    }

    var item = JSON.parse(stringItem);

    // compare the expiry time of the item with the current time
    if (new Date().getTime() > item.expiry) {
      // if the item is expired, delete the item from storage and return null
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  },
  remove: function remove(key) {
    localStorage.removeItem(key);
  }
});

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_index_js__ = __webpack_require__(40);





var authServer = "https://authservice.trransfer.com";

var SecurityService = function () {
  function SecurityService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SecurityService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SecurityService, [{
    key: "signIn",


    // Redirect of the current window to the authorization endpoint.
    value: function signIn() {
      __WEBPACK_IMPORTED_MODULE_4__store_index_js__["a" /* default */].dispatch("user/removeProfile");
      __WEBPACK_IMPORTED_MODULE_4__store_index_js__["a" /* default */].dispatch("user/removeToken");
      __WEBPACK_IMPORTED_MODULE_4__store_index_js__["a" /* default */].dispatch("user/removeUser");
      __WEBPACK_IMPORTED_MODULE_4__store_index_js__["a" /* default */].dispatch("setting/removeSetting");
      window.location.href = authServer + "/login";
    }

    // Redirect of the current window to the end session endpoint

  }, {
    key: "signOut",
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_4__store_index_js__["a" /* default */].dispatch("user/removeProfile");
      __WEBPACK_IMPORTED_MODULE_4__store_index_js__["a" /* default */].dispatch("user/removeToken");
      __WEBPACK_IMPORTED_MODULE_4__store_index_js__["a" /* default */].dispatch("user/removeUser");
      __WEBPACK_IMPORTED_MODULE_4__store_index_js__["a" /* default */].dispatch("setting/removeSetting");
      window.location.href = authServer + "/logout";
    }

    // Get the user who is logged in

  }, {
    key: "getUser",
    value: function getUser() {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(authServer + "/user", {
          credentials: "include" // fetch won't send cookies unless you set credentials
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data == null || data.user == undefined || data.user == null) {
            self.signIn();
            return resolve(null);
          } else {
            var usr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data.user);
            data.user.profile = usr;
            return resolve(data.user);
          }
        }).catch(function (err) {
          return reject(err);
        });
      });
    }

    // Check if there is any user logged in

  }, {
    key: "getSignedIn",
    value: function getSignedIn() {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(authServer + "/issignedin", {
          credentials: "include" // fetch won't send cookies unless you set credentials
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data == null || data.user == undefined || data.user == null || !data.user.active) {
            self.signIn();
            return resolve(false);
          } else {
            return resolve(true);
          }
        }).catch(function (err) {
          return reject(err);
        });
      });
    }

    // Get the profile of the user logged in

  }, {
    key: "getProfile",
    value: function getProfile() {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(authServer + "/user", {
          credentials: "include" // fetch won't send cookies unless you set credentials
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data == null || data.user == undefined || data.user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(data.user);
          }
        }).catch(function (err) {
          return reject(err);
        });
      });
    }

    // Get the access token of the logged in user

  }, {
    key: "getAcessToken",
    value: function getAcessToken() {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(authServer + "/acctoken", {
          credentials: "include" // fetch won't send cookies unless you set credentials
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data == null || data.token == undefined || data.token == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(data);
          }
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }]);

  return SecurityService;
}();

/* harmony default export */ __webpack_exports__["a"] = (SecurityService);

/***/ })

},[240]);


// WEBPACK FOOTER //
// static/js/app.00f330a32cec7c3e5f79.js